import {
  ClipboardList,
  Signpost,
  Home,
  Zap,
  Flame,
  Droplets,
  Wind,
  Thermometer,
  SlidersHorizontal,
  Wrench,
  Snowflake,
  Utensils,
  Fuel,
  MapPinned,
  Accessibility,
  Bath,
  Info,
  Building2,
  Package,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

const ACCENT_CLASSES: Record<string, string> = {
  sky: "border-sky-500/40 bg-sky-500/15 text-sky-400",
  blue: "border-blue-500/40 bg-blue-500/15 text-blue-400",
  cyan: "border-cyan-500/40 bg-cyan-500/15 text-cyan-400",
  teal: "border-teal-500/40 bg-teal-500/15 text-teal-400",
  emerald: "border-emerald-500/40 bg-emerald-500/15 text-emerald-400",
  green: "border-green-500/40 bg-green-500/15 text-green-400",
  lime: "border-lime-500/40 bg-lime-500/15 text-lime-400",
  amber: "border-amber-500/40 bg-amber-500/15 text-amber-400",
  orange: "border-orange-500/40 bg-orange-500/15 text-orange-400",
  red: "border-red-500/40 bg-red-500/15 text-red-400",
  rose: "border-rose-500/40 bg-rose-500/15 text-rose-400",
  violet: "border-violet-500/40 bg-violet-500/15 text-violet-400",
  indigo: "border-indigo-500/40 bg-indigo-500/15 text-indigo-400",
  purple: "border-purple-500/40 bg-purple-500/15 text-purple-400",
  slate: "border-slate-500/40 bg-slate-500/15 text-slate-300",
};

const DEFAULT_ACCENT = "border-primary/40 bg-primary/15 text-primary";

const CATEGORY_ICON_RULES: { keywords: string[]; icon: LucideIcon; accent: string }[] = [
  { keywords: ["signage", "sign"], icon: Signpost, accent: "sky" },
  { keywords: ["roof"], icon: Home, accent: "orange" },
  { keywords: ["envelope", "heat load", "insulation", "thermal"], icon: Thermometer, accent: "rose" },
  { keywords: ["exterior", "facade"], icon: Building2, accent: "blue" },
  { keywords: ["electric", "power", "distribution"], icon: Zap, accent: "amber" },
  { keywords: ["gas"], icon: Flame, accent: "red" },
  { keywords: ["plumb", "water", "sewer"], icon: Droplets, accent: "cyan" },
  { keywords: ["hvac", "ventilation", "air"], icon: Wind, accent: "teal" },
  { keywords: ["control", "automation", "building system"], icon: SlidersHorizontal, accent: "violet" },
  { keywords: ["utility", "mechanical"], icon: Wrench, accent: "slate" },
  { keywords: ["interior"], icon: Package, accent: "indigo" },
  { keywords: ["refrig", "cooler", "freezer", "cold"], icon: Snowflake, accent: "cyan" },
  { keywords: ["food", "kitchen"], icon: Utensils, accent: "emerald" },
  { keywords: ["fuel", "canopy", "pump", "dispenser"], icon: Fuel, accent: "orange" },
  { keywords: ["site", "ground", "parking"], icon: MapPinned, accent: "green" },
  { keywords: ["ada", "life safety", "accessib"], icon: Accessibility, accent: "purple" },
  { keywords: ["restroom", "bathroom", "toilet"], icon: Bath, accent: "teal" },
  { keywords: ["store", "information"], icon: Info, accent: "indigo" },
];

function getCategoryRule(title: string) {
  const normalized = title.toLowerCase();
  return CATEGORY_ICON_RULES.find((rule) =>
    rule.keywords.some((keyword) => normalized.includes(keyword))
  );
}

export function getCategoryIcon(title: string): LucideIcon {
  return getCategoryRule(title)?.icon ?? ClipboardList;
}

export function getCategoryAccentClasses(title: string): string {
  const accent = getCategoryRule(title)?.accent;
  return (accent && ACCENT_CLASSES[accent]) || DEFAULT_ACCENT;
}
